import { Entity } from '@decahedron/entity';

export default class Sell extends Entity {
  public id: string = null;

  public make: string = null;

  public model: string = null;

  public firstRegistration: string = null;

  public mileage: string = null;

  public fuel: string = null;

  public color: string = null;

  public description: string = null;

  public firstname: string = null;

  public lastname: string = null;

  public email: string = null;

  public phone: string = null;

  public language: string = null;

  public sent: string = null;

  get descriptionBrs() {
    return this.description.replace(/(?:\r\n|\r|\n)/g, '<br>');
  }
}
